import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import { Typography, Input, Button, Dropdown, Menu, Icon, message, Tabs } from "antd";
import { ContextAPI } from "../../../ContextAPI";
import { platformApi } from '../../../api';
import PaymentModal from '../../paymentModal';
import { useBranch } from '../../../ContextAPI/branch';

import InvoiceTable from './InvoiceTable';

const { Item } = Menu;
const { Search } = Input;
const { TabPane } = Tabs;
const { Title } = Typography;

const JobInvoiceTable = () => {

  const history = useHistory();
  const { loginCredintials } = useContext(ContextAPI);
  // const isCEO = loginCredintials?.role === 'CEO';
  const [dataSourceForPending, setDataForPending] = useState([]);
  const [dataSourceForPaid, setDataForPaid] = useState([]);
  const [editable, setEditable] = useState(false);
  const [createAccess, setCreateAccess] = useState(false);
  const [modifyAccess, setModifyAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);
  const [printAccess, setPrintAccess] = useState(false)
  const [editableData, setEditableData] = useState({})
  const [redirect, setRedirect] = useState(false);
  const [selected, setSelected] = useState();
  const [spinning, setSpinning] = useState(false);

  const { selectBranch } = useBranch();

  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [search, setSearch] = useState('');
  const [selectedRow, setSelectedRow] = useState(null);
  const [paymentModalVisible, setPaymentModalVisible] = useState(false);

  const [gst, setGst] = useState();
  const [tab, setTab] = useState(1)

  useEffect(() => {
    setGst(loginCredintials.branch[0].gst)
    loginCredintials.roleAccess &&
      loginCredintials.roleAccess.map((each) => {
        if (each.subModule === "job_invoice") {
          if (each.access.create) {
            setCreateAccess(true);
          }
          if (each.access.update) {
            setModifyAccess(true);
          }
          if (each.access.delete) {
            setDeleteAccess(true);
          }
          if (each.access.print) {
            setPrintAccess(true);
          }
        }
      });
    setPageDataForPending();
    //getSSI();
  }, []);

  const openPaymentModal = (row) => {
    setSelectedRow(row);
    setPaymentModalVisible(true);
  };

  const updateJobInvoiceStatus = async (invoiceId) => {
    try {
      const res = await platformApi.post("/api/jobInvoice/updateStatus", {
        id: invoiceId,
        status: "PAID"
      });

      if (res.data.code === 200 && res.data.response.code === 200) {
        setPageDataForPending(search);  // refresh table
      } else {
        message.error("Failed to update status");
      }
    } catch (err) {
      console.error(err);
      message.error("API Error");
    }
  };



  useEffect(() => {
    if (tab == 1) {
      setPageDataForPending(search);
    }
    else if (tab == 2) {
      setPageDataForPaid(search)
    }
  }, [page, limit, search]);

  const getMenu = () => {
    let size = count / 10 + (count % 10) ? 1 : 0;
    const menus = [];
    menus.push(10);
    size = size <= 10 ? size : 10;
    for (let itr = 2; itr <= size; itr++) menus.push(itr * 10);
    return menus.map((menu) => (
      <Item onClick={() => { setLimit(menu), setPage(1) }} key={menu}>
        {menu}
      </Item>
    ));
  };
  const menu = <Menu>{getMenu()}</Menu>;

  const setPageDataForPending = (search, val) => {
    setSpinning(true)
    platformApi
      .post("/api/jobInvoice/get", {
        page: val ? val : page,
        size: limit,
        jobStatus: ["Work In Progress", "Vehicle Received", "Estimation", "Proforma Invoice", "Mechanic Allocated"],
        searchString: search,
        branch: Array.isArray(selectBranch) ? selectBranch.map((b) => b.id) : []
      })
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setDataForPending(response.data.saleSpareInvoice);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch sale job invoice", 2);
          }
        } else {
          message.error("Unable to fetch sale job invoice", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Vehicle Sale job invoice : ", error);
        message.error("Unable to fetch sale job invoice", 2);
      });
  };
  const setPageDataForPaid = (search, val) => {
    setSpinning(true)
    platformApi
      .post("/api/jobInvoice/get", {
        page: val ? val : page,
        size: limit,
        jobStatus: ["PAID"],
        searchString: search,
        branch: Array.isArray(selectBranch) ? selectBranch.map((b) => b.id) : []
      })
      .then((result) => {
        setSpinning(false);
        let { data } = result;
        if (data.code === 200) {
          let { response } = data;
          if (response.code === 200) {
            setDataForPaid(response.data.saleSpareInvoice);
            setCount(response.data.count);
          } else {
            message.error("Unable to fetch sale job invoice", 2);
          }
        } else {
          message.error("Unable to fetch sale job invoice", 2);
        }
      })
      .catch((error) => {
        console.error("Error on Vehicle Sale job invoice : ", error);
        message.error("Unable to fetch sale job invoice", 2);
      });
  }
  const getSSI = () => {
    setSpinning(true)
    platformApi.get("/api/jobInvoice").then((result) => {
      setSpinning(false)
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          setDataForPending(response.data.saleshareInvoice);
          setCount(response.data.count);
        } else {
          message.error('Unable to fetch vehicles', 2);
        }
      } else {
        message.error('Unable to fetch vehicles', 2);
      }
    })
      .catch((err) => {
        setSpinning(false)
        console.error("SSI Fetch Error: ", err);
        message.error("Couldn't Fetch SSI");
      });
  }


  const deleteData = (id) => {
    setSpinning(true);
    const currentList = tab === 1 ? dataSourceForPending : dataSourceForPaid;
    let temp = page != 1 && currentList.length === 1;
    platformApi.delete("/api/jobInvoice/" + id).then(result => {
      let { data } = result;
      if (data.code === 200) {
        let { response } = data;
        if (response.code === 200) {
          message.success("SSI Deleted Successfully")
          if (temp) {
            setPage(1)
            if (tab === 1) {
              setPageDataForPending(search, 1);
            } else {
              setPageDataForPaid(search, 1);
            }
          }
          else {
            if (tab === 1) {
              setPageDataForPending(search);
            } else {
              setPageDataForPaid(search);
            }
          }
        }
        else {
          setSpinning(false)
          message.error("Couldn't Remove SSI");
        }
      }
      else {
        setSpinning(false)
        message.error("Couldn't Remove SSI");
      }
    }).catch((err) => {
      setSpinning(false)
      console.error("SSI Delete Error: ", err);
      message.error("Unable to Delete SSI");
    });
  }
  const handleTabChange = (activeKey) => {
    if (activeKey == 1) {
      setTab(1)
      setPageDataForPending()
    }
    else if (activeKey == 2) {
      setTab(2)
      setPageDataForPaid()
    }
    setSearch("")
    setCount(0)
    setPage(1)
    setLimit(10)
  }
  return (
    <>
      <div className="accessories-head">
        <Title style={{ width: "60%" }} level={4}>
          Job Invoice[{count}]
          <span style={{ marginLeft: "1rem" }}>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button>
                {limit} &nbsp;
                <Icon type="down" />
              </Button>
            </Dropdown>
          </span>
        </Title>
        <Search
          style={{ width: "30%" }}
          placeholder="Search Job Invoice"
          onSearch={(event) => {
            setPage(1)
            setSearch(event);
          }}
          onChange={(event) => {
            if (event.target.value === "") {
              setSearch(null)
              setPage(1)
            }
          }}
        />
        <Button
          onClick={() => {
            history.push({
              pathname: '/autoadmin/job_invoice/:id',
              state: {
                gst: gst
              }
            })
            // history.push('/autoadmin/sale_spares_invoice/:id');
          }}
          style={{ margin: "0 3%", width: "20%" }}
          type="primary"
          disabled={!createAccess}
        >
          Add Job Invoice
        </Button>
      </div>

      <Tabs defaultActiveKey="1"
        onChange={handleTabChange}
      >
        <TabPane
          tab={
            <span>
              Pending
            </span>
          }
          key="1"
        >
          <InvoiceTable
            openPaymentModal={openPaymentModal}
            updateJobInvoiceStatus={updateJobInvoiceStatus}
            showPaymentActions={true}
            gst={gst}
            dataSource={dataSourceForPending}
            spinner={spinning}
            deleteData={deleteData}
            setEditableData={setEditableData}
            setEditable={setEditable}
            modify={modifyAccess}
            setModifyAccess={setModifyAccess}
            redirectPage={(id, editable) => {
              setSelected(id);
              setRedirect(true);
              setEditable(editable);
            }}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              defaultCurrent: 1,
              current: page,
              total: count,
              showQuickJumper: true,
            }}
            deleteAccess={deleteAccess}
            printAccess={printAccess}
          />
        </TabPane>
        <TabPane
          tab={
            <span>
              Paid
            </span>
          }
          key="2"
        >
          <InvoiceTable
            updateJobInvoiceStatus={updateJobInvoiceStatus}
            showPaymentActions={false}
            gst={gst}
            dataSource={dataSourceForPaid}
            spinner={spinning}
            deleteData={deleteData}
            setEditableData={setEditableData}
            setEditable={setEditable}
            modify={false}
            setModifyAccess={setModifyAccess}
            redirectPage={(id, editable) => {
              setSelected(id);
              setRedirect(true);
              setEditable(editable);
            }}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              defaultCurrent: 1,
              current: page,
              total: count,
              showQuickJumper: true,
            }}
            deleteAccess={deleteAccess}
            printAccess={printAccess}
          />
        </TabPane>
      </Tabs>
      {paymentModalVisible && (
        <PaymentModal
          visible={paymentModalVisible}
          onClose={() => setPaymentModalVisible(false)}
          data={selectedRow}
          module="JOB_INVOICE"
          moduleId={selectedRow?.id}
          branchId={selectedRow?.branch?.id}
          onSuccess={() => {
            setPaymentModalVisible(false);
            setPageDataForPending(search);
          }}
          jobInvoice="true"
        />
      )}
    </>
  )
}

export default JobInvoiceTable;



/*



 <InvoiceTable
            gst={gst}
            dataSource={dataSourceForPaid}
            spinner={spinning}
            deleteData={deleteData}
            setEditableData={setEditableData}
            setEditable={setEditable}
            modify={modifyAccess}
            setModifyAccess={setModifyAccess}
            redirectPage={(id, editable) => {
              setSelected(id);
              setRedirect(true);
              setEditable(editable);
            }}
            pagination={{
              onChange: (page) => {
                setPage(page);
              },
              pageSize: limit,
              defaultCurrent: 1,
              current: page,
              total: count,
              showQuickJumper: true,
            }}
          />


*/